<div class='container audio-div'>
    <div class="close-button" (click)="onClose()">
        <span class="iconify" data-icon="mdi:close" data-inline="false" data-width="24" data-height="24"
            style="color: #6f3974;"></span>
    </div>
    <h4>{{audio.title}}</h4>
    <h6>{{audio.description}}</h6>
    <audio id="audio_example" controls controlsList="nodownload" preload="auto" autoplay src="{{audio.path}}">
    </audio>
</div>